export default __webpack_public_path__ + "_/images/freespins/freespins-100-077b54051d8c9bf4a0d9ba079a2823bd02e92f07be1b8d66c3c4f6a2c3d62ee3.png";